import { defineEntity, entity, foreign, object, string } from '~/prix'
import sql from '~/prix/utils/sql'

const cnaeDivision = defineEntity({
  key: 'cnaeDivision',
  title: 'Divisão de cnae',
  sources: ['olap', 'oltp'],
  schema: object({
    id: string().label('ID'),
    ibgeCode: string().label('Código IBGE'),
    description: string().label('Descrição'),
    observations: string().label('Observações'),
    cnaeSectionId: foreign(entity('cnaeSection').property('id')),
  }),
})

export const cnaeDivisionPropertyMap = {
  id: sql`cnae_division.id`,
  ibgeCode: sql`cnae_division.ibge_code`,
  description: sql`cnae_division.description`,
  observations: sql`cnae_division.observations`,
  cnaeSectionId: sql`cnae_division.cnae_section_id`,
}

export default cnaeDivision
